import { render, staticRenderFns } from "./nvLayout.vue?vue&type=template&id=84f353d6&scoped=true&"
import script from "./nvLayout.vue?vue&type=script&lang=ts&"
export * from "./nvLayout.vue?vue&type=script&lang=ts&"
import style0 from "./nvLayout.vue?vue&type=style&index=0&id=84f353d6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f353d6",
  null
  
)

export default component.exports